import { MouseEvent, useState } from 'react';
import { API_Response } from '../../types';
import { copyShortcodeToClipboard, getAmountFromCents } from '../../helpers';

import * as S from './styled';
import DeleteModal from '../modals/DeleteModal';

interface DashboardItemProps {
	data: API_Response;
	onDelete: () => void;
}

const DashboardItem = ({ data, onDelete }: DashboardItemProps) => {
	const initialCopyShortcodeText = 'Copy shortcode';
	const [copyShortcodeText, setCopyShortcodeText] = useState<string>(initialCopyShortcodeText);
	const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
	const [itemState, setItemState] = useState<'default' | 'deleting'>('default');

	function handleCopyShortcodeClick() {
		copyShortcodeToClipboard(data.ID);
		setCopyShortcodeText('Copied!');

		setTimeout(() => {
			setCopyShortcodeText(initialCopyShortcodeText);
		}, 2000);
	}

	function handleDeleteButtonClick(e: MouseEvent) {
		e.preventDefault();
		setShowDeleteModal(true);
	}

	function deleteItem() {
		setItemState('deleting');
		setShowDeleteModal(false);
		onDelete();
	}

	return (
		<>
			<S.Container itemState={itemState}>
				<S.Preview>
					<S.DialogHeader>{data.dialog_header}</S.DialogHeader>
					<S.Amounts>
						{data.all_amounts.map((amount, index) => (
							<S.Amount key={index}>{`$${getAmountFromCents(amount as number)}`}</S.Amount>
						))}
						<S.Amount>custom</S.Amount>
					</S.Amounts>
				</S.Preview>
				<S.Info>
					<S.Title>
						{data.post_title || 'Untitled'}
						<S.Type>{data.layout_type}</S.Type>
					</S.Title>
					<S.Time>{data.created_updated_info}</S.Time>
					<S.Buttons>
						<S.BasicLink onClick={() => handleCopyShortcodeClick()}>{copyShortcodeText}</S.BasicLink>
						<S.RouterLink to={`/contributions/builder/${data.ID}`}>Edit</S.RouterLink>
						<S.BasicLink onClick={e => handleDeleteButtonClick(e)}>Delete</S.BasicLink>
					</S.Buttons>
				</S.Info>
			</S.Container>

			{showDeleteModal && <DeleteModal onConfirm={deleteItem} onCancel={() => setShowDeleteModal(false)} />}
		</>
	);
};

export default DashboardItem;
